import { useNavigate } from 'react-router';
import { TransactionsTable } from '../components/TransactionsTable';

export const Transactions = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Transactions</h1>
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate('/transactions/user/new')}
            className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition-colors"
          >
            New User Transaction
          </button>
          <button
            onClick={() => navigate('/transactions/merchant/new')}
            className="px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition-colors"
          >
            Merchant Topup
          </button>
        </div>
      </div>
      <TransactionsTable />
    </div>
  );
}
